var map = {
	"./Songs/Audio/all_i_know.wav": 800,
	"./Songs/Audio/blossom.wav": 7546,
	"./Songs/Audio/dance_destiny.wav": 5588,
	"./Songs/Audio/fear_of_regret.wav": 7437,
	"./Songs/Audio/feel_it_more.wav": 3553,
	"./Songs/Audio/find_a_way.wav": 3240,
	"./Songs/Audio/headphones_on.wav": 3837,
	"./Songs/Audio/in_the_now.wav": 4963,
	"./Songs/Audio/my_eyes.wav": 6712,
	"./Songs/Audio/never_too_far.wav": 6794,
	"./Songs/Audio/no_more_love.wav": 4394,
	"./Songs/Audio/sequence.wav": 4830,
	"./Songs/Audio/silver_chain.wav": 7706,
	"./Songs/Audio/telepathic_dream.wav": 4829,
	"./Songs/Audio/the_image.wav": 6065,
	"./Songs/Audio/through_the_motions.wav": 2426,
	"./Songs/Audio/timeless_night.wav": 5029,
	"./Songs/Audio/too_early.wav": 3150,
	"./Songs/CoverArts/dance_destiny.jpg": 1482,
	"./Songs/CoverArts/does_this_last.jpeg": 8617,
	"./Songs/CoverArts/fear_of_regret.jpeg": 58,
	"./Songs/CoverArts/headphones_on.jpg": 9472,
	"./Songs/CoverArts/in_control.jpeg": 4407,
	"./Songs/CoverArts/reality_to_another.jpeg": 9050,
	"./Songs/CoverArts/silver_chain.png": 4746,
	"./Songs/CoverArts/the_image.jpeg": 9012,
	"./Songs/CoverArts/through_the_motions.jpeg": 17,
	"./Songs/CoverArts/timeless_night.jpg": 5028,
	"./Songs/tracks": 5714,
	"./Songs/tracks.js": 5714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7177;